import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Input } from '../../../elements/input';
import { useTranslation } from 'react-i18next';
import { classNames } from '../../../utils';
import { useHttpClient } from '../../../shared/http-client';
import { FieldError } from '../../../elements/field-error/field-error';
import { Button } from '../../../elements/button';
import { Select } from '../../../elements/select';
import { FileInputElement } from '../../../elements/file-input';
import { Toggle } from '../../../elements/toggle';
import { DatePicker } from '../../../elements/date-picker';




// construccion del objeto yup de validacion del cuestionario
let obligado = {
    plate: Yup.string().required('obligatorio'),
    brand: Yup.mixed().required('obligatorio'),
    model: Yup.mixed().required('obligatorio'),
    color: Yup.string().required('obligatorio'),
    chassis_number: Yup.string().required('obligatorio'),
    tank_capacity: Yup.number().required('obligatorio'),
    registration_date: Yup.string().required('obligatorio'),
    //registration_number: Yup.string().required('obligatorio'),
    registration_country: Yup.mixed().required('obligatorio'),
    //purchase_company: Yup.mixed().required('obligatorio'),
    //purchase_date: Yup.string().required('obligatorio'),
    //gps_date: Yup.string().required('obligatorio'),
    //gps_number: Yup.string().required('obligatorio'),
    //gps_imei: Yup.string().required('obligatorio'),
    //gps_sim: Yup.string().required('obligatorio'),
    //responsible: Yup.mixed().required('obligatorio'),
    maintenance_km_interval: Yup.number()
        .nullable()
        .transform((value, originalValue) =>
            originalValue === '' ? null : value
        )
        .moreThan(0, 'no-positive-number.error'),
    maintenance_time_interval_months: Yup.number()
        .nullable()
        .transform((value, originalValue) =>
            originalValue === '' ? null : value
        )
        .moreThan(0, 'no-positive-number.error')
};
const validacion = Yup.object().shape(obligado);

const initialValues: any = {
    plate: '',
    brand: null,
    model: null,
    color: '',
    mileage: '',
    chassis_number: '',
    registration_date: '',
    //registration_number: '',
    registration_country: null,
    //purchase_company: null,
    //purchase_date: '',
    gps_date: '',
    gps_number: '',
    gps_imei: '',
    gps_sim: '',
    tank_capacity: 40
    //responsible: null

};

export const VehiculosForm = ({
    onAction,
    isEdit
}: {
    onAction?: () => void;
    isEdit: boolean;
}) => {
    const { t } = useTranslation() as { t: (key: string) => string };

    const { api, state } = useHttpClient();
    const { id } = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState<any | null>(null);
    const [brands, setBrands] = useState<any | null>([]);
    const [brand, setBrand] = useState<any | null>(null);
    const [models, setModels] = useState<any | null>([]);
    const [countries, setCountries] = useState<any | null>([]);
    const [companies, setCompanies] = useState<any | null>([]);
    const [users, setUsers] = useState<any | null>([]);
    const [isDeleted, setIsDeleted] = useState<boolean>(false);
    const [isPreview, setIsPreview] = useState<boolean>(false);

    // Este estado guardará la URL de la imagen subida
    const [preview, setPreview] = useState<string | null>(null);


    // Limpia el objectURL cuando el componente se desmonte o cambie la preview
    useEffect(() => {
        return () => {
            if (preview && preview.startsWith('blob:')) {
                URL.revokeObjectURL(preview);
            }
        };
    }, [preview]);

    // Load initial data
    useEffect(() => {
        if (id) {
            api(`/fleet/vehicles/${id}/`, 'GET');
        }
        api('/fleet/car-brands/?limit=9999', 'GET');
    }, [id]);

    const beforeSubmit = (values: any) => {
        const after = { ...values };

        return after;
    };

    const onSubmit = async (values: any) => {
        const enviaremos = beforeSubmit(values);

        let formdata = new FormData();

        console.log('enviaremos', enviaremos)

        if (enviaremos.photo) {
            if (enviaremos.photo.photo) {
                formdata.append(
                    'photo',
                    enviaremos.photo.photo[0],
                    enviaremos.photo.photo[0].name
                );
            } else {
                delete enviaremos.photo;
            }
        }

        if (enviaremos.purchase_invoice) {
            if (enviaremos.purchase_invoice.purchase_invoice) {
                formdata.append(
                    'purchase_invoice',
                    enviaremos.purchase_invoice.purchase_invoice[0],
                    enviaremos.purchase_invoice.purchase_invoice[0].name
                );
            } else {
                delete enviaremos.purchase_invoice;
            }
        }

        for (let key in enviaremos) {
            if (key !== 'photo' && key !== 'purchase_invoice') {
                formdata.append(key, enviaremos[key] ? enviaremos[key] : "");
            }
        }

        if (isDeleted) {
            api(`/fleet/vehicles/${enviaremos.id}/`, 'PATCH', enviaremos);
        } else {
            if (enviaremos.id) {
                // update

                api(`/fleet/vehicles/${enviaremos.id}/`, 'PATCH', formdata, true);
            } else {
                // create

                api('/fleet/vehicles/', 'POST', formdata, true);
            }
        }






    };

    const openInNewTab = (url: any) => {
        window.open(url, '_blank', 'noreferrer');
    };

    // Handle API responses
    useEffect(() => {
        if (state.data) {
            if (state.path.includes('/fleet/vehicles/')) {
                if (state.method === 'POST' || state.method === 'PATCH') {
                    toast.success(`${t('common.label.success-saved')}`);
                    
                    if (!id) {
                        navigate(-1);
                    }else{
                        window.location.reload();
                    }
                }
                if (state.method === 'GET') {
                    setData(state.data);
                }
            }
            if (state.path.includes('/fleet/car-brands/')) {
                setBrands(state.data.results);
                api('/fleet/car-models/?limit=9999', 'GET');
            }
            if (state.path.includes('models')) {
                setModels(state.data.results);
                api('/fleet/countries/?limit=9999', 'GET');
            }
            if (state.path.includes('countries')) {
                setCountries(state.data.results);
                //api('/fleet/companies/?limit=9999', 'GET');
                api('/fleet/users/?limit=9999', 'GET');
            }
            if (state.path.includes('companies')) {
                setCompanies(state.data.results);
                api('/fleet/users/?limit=9999', 'GET');
            }
            if (state.path.includes('users')) {
                setUsers(state.data.results);
            }
        }

        if (state.error) {
             toast.error('Server Error');
        }
    }, [state]);

    return (

        <>
            {isEdit ? <div className="text-[22px] text-gray-900 pl-4 pt-8">
                {t('common.label.general')}
            </div> : ''}
            <Formik
                initialValues={data || initialValues}
                onSubmit={onSubmit}
                validationSchema={validacion}
                enableReinitialize
            >
                {({
                    values,
                    errors,
                    touched,
                    setFieldValue,
                    handleSubmit,
                    isSubmitting
                }) => (
                    <form onSubmit={handleSubmit} autoComplete="off">

                        <div className='flex p-4'>
                            <div className='w-2/3'>

                                <div className='flex space-x-8'>
                                    <div className='w-full'>
                                        <Input
                                            label={t('common.form-label.matricula')}
                                            type="text"
                                            placeholder={t('common.form-label.matricula')}
                                            name="plate"
                                            value={values.plate}
                                            onChange={(value) =>
                                                setFieldValue('plate', value.plate)
                                            }
                                        />
                                        <FieldError
                                            touched={touched}
                                            errors={errors}
                                            field={'plate'}
                                        />
                                    </div>

                                    {/* --------------------MARCA-------------------  */}
                                    <div className='mt-[-4px] w-full'>
                                        <Select
                                            name="brand"
                                            label={t('common.label.marca')}
                                            placeholder="Select value"
                                            items={brands}
                                            value={values.brand || data?.model?.brand?.id}
                                            onChange={(value) => {
                                                setFieldValue('brand', value.brand);
                                                setBrand(value.brand);
                                                api(`/fleet/car-models/?brand=${value.brand}&limit=9999`, 'GET');
                                            }}
                                        />
                                        <FieldError touched={touched} errors={errors} field={"brand"} />
                                    </div>

                                    {/* --------------------MARCA ------------------- */}
                                    {/* --------------------MODELO-------------------  */}
                                    <div className='mt-[-4px] w-full'>
                                        {brand ? <> <Select
                                            name="model"
                                            label={t('common.label.modelo')}
                                            placeholder="Select value"
                                            items={models}
                                            value={values.model}
                                            onChange={(value) => {
                                                setFieldValue('model', value.model);
                                            }}
                                        />
                                            <FieldError touched={touched} errors={errors} field={"model"} />
                                        </> : ''}

                                    </div>


                                    {/* --------------------MODELO------------------- */}

                                    <div className='w-full'>
                                        <Input
                                            label={t('common.label.color')}
                                            type="text"
                                            placeholder={t('common.label.color')}
                                            name="color"
                                            value={values.color}
                                            onChange={(value) =>
                                                setFieldValue('color', value.color)
                                            }
                                        />
                                        <FieldError
                                            touched={touched}
                                            errors={errors}
                                            field={'color'}
                                        />
                                    </div>

                                </div>


                                <div className='flex space-x-8 mt-4'>
                                    {id ? <div className='w-full'>
                                        <Input
                                            label={t('common.label.km')}
                                            type="text"
                                            placeholder={t('common.label.km')}
                                            name="mileage"
                                            value={values.mileage}
                                            onChange={(value) =>
                                                setFieldValue('mileage', value.mileage)
                                            }
                                            disabled
                                        />
                                    </div> : ''}
                                    <div className='w-full pt-8 flex'>
                                        <div className='not-italic font-medium text-sm leading-6'>{t('common.form-label.disponible')}:</div> <div className='pl-4'>{data?.available ? t('common.label.yes') : t('common.label.no')}</div>

                                    </div>

                                    <div className='w-full pt-8'>
                                        <Toggle
                                            label={t('common.label.bloqueado')}
                                            hasInfo
                                            value={values.blocked}
                                            onChange={(value: any) =>
                                                setFieldValue('blocked', value.toggle)
                                            }
                                        />
                                    </div>
                                </div>
                                <div className='mt-4 flex space-x-8'>

                                    <div className='mt-1 w-2/3'>
                                        <Input
                                            label={t('common.form-label.descripcion')}
                                            type="text"
                                            placeholder={t('common.form-label.descripcion')}
                                            name="description"
                                            value={values.description}
                                            onChange={(value) =>
                                                setFieldValue('description', value.description)
                                            }
                                        />
                                    </div>
                                    <div className='w-1/3 pt-[4px]'>
                                        <Input
                                            label={t('common.label.revision-cada-km')}
                                            type="number"
                                            placeholder={t('common.label.revision-cada-km')}
                                            name="maintenance_km_interval"
                                            value={values.maintenance_km_interval}
                                            onChange={(value) =>
                                                setFieldValue('maintenance_km_interval', value.maintenance_km_interval)
                                            }
                                        />
                                        <FieldError touched={touched} errors={errors} field={"maintenance_km_interval"} />

                                    </div>
                                    <div className='w-1/3 pt-[4px]'>
                                        <Input
                                            label={t('common.label.revision-cada-meses')}
                                            type="number"
                                            placeholder={t('common.label.revision-cada-meses')}
                                            name="maintenance_time_interval_months"
                                            value={values.maintenance_time_interval_months}
                                            onChange={(value) =>
                                                setFieldValue('maintenance_time_interval_months', value.maintenance_time_interval_months)
                                            }
                                        />
                                        <FieldError touched={touched} errors={errors} field={"maintenance_time_interval_months"} />
                                    </div>
                                    <div className='w-1/3 pt-[4px]'>
                                        <Input
                                            label={t('common.label.capacidad-tanque')}
                                            type="number"
                                            placeholder={t('common.label.capacidad-tanque')}
                                            name="tank_capacity"
                                            value={values.tank_capacity}
                                            onChange={(value) =>
                                                setFieldValue('tank_capacity', value.tank_capacity)
                                            }
                                        />
                                        <FieldError touched={touched} errors={errors} field={"tank_capacity"} />
                                    </div>
                                    {/*  <div className='w-1/3'>
                                        <Select
                                            name="responsible"
                                            label={t('common.form-label.persona-responsable')}
                                            placeholder="Select value"
                                            items={users}
                                            value={data?.responsible || values.responsible}
                                            onChange={(value) =>
                                                setFieldValue('responsible', value.responsible)
                                            }
                                        />
                                        <FieldError
                                            touched={touched}
                                            errors={errors}
                                            field={'responsible'}
                                        />

                                    </div> */}

                                </div>

                            </div>
                            <div className='w-1/3 pl-8'>
                            <div>
                                    {data?.photo_display_url ? <span className="block text-sm font-semibold leading-6 text-gray-700">{t('common.form-label.foto')}</span> : <span className="block text-sm font-semibold leading-6 text-gray-700">{t('common.form-label.foto')}</span>}
                                    {data?.photo_display_url && !isPreview ? <div className=''>
                                        <img className='w-[150px] pb-4' src={data?.photo_display_url} />
                                    </div> : ''
                                    }
                                </div>
                                {/* PREVIEW DE LA FOTO */}
                                {preview && isPreview && (
                                    <div className="mb-4">
                                        <img className="h-[150px] object-cover rounded" src={preview} alt="Vista previa" />
                                    </div>
                                )}

                                <div>


                                    <FileInputElement
                                        name="photo"
                                        accept="image/png, image/jpeg"
                                        onChange={(value: any) => {
                                            // value.photo es un FileList
                                            const file = value.photo?.[0];
                                            setFieldValue('photo', value);
                                            if (file) {
                                                // Generamos un objectURL para la vista previa
                                                const url = URL.createObjectURL(file);
                                                setPreview(url);
                                                setIsPreview(true);
                                            } else {
                                                setPreview(null);
                                                setIsPreview(false);
                                            }
                                        }}
                                    />
                                </div>
                            </div>



                        </div>
                        <div className='w-full flex space-x-8 p-4'>
                            <div className='w-6/12 border border-gray-400 rounded p-8'>
                                <div className="text-[15px]  text-gray-900 pb-4 pr-4 font-semibold">
                                    {t('common.form-label.matriculacion')}
                                </div>
                                <div className='w-full'>
                                    <Input
                                        label={t('common.label.numero-bastidor')}
                                        type="text"
                                        placeholder={t('common.label.numero-bastidor')}
                                        name="chassis_number"
                                        value={values.chassis_number}
                                        onChange={(value) =>
                                            setFieldValue('chassis_number', value.chassis_number)
                                        }
                                    />
                                    <FieldError
                                        touched={touched}
                                        errors={errors}
                                        field={'chassis_number'}
                                    />

                                    <DatePicker
                                        name="registration_date"
                                        type="date"
                                        label={t('common.label.fecha-matriculacion')}
                                        value={
                                            (data ? dayjs(data.registration_date).format('YYYY-MM-DD') : '') || values.registration_date}
                                        onChange={(value) => {
                                            setFieldValue('registration_date', value.registration_date ? dayjs(value.registration_date).format('YYYY-MM-DD') : null);
                                        }}
                                    />
                                    <FieldError
                                        touched={touched}
                                        errors={errors}
                                        field={'registration_date'}
                                    />

                                    {/*   <Input
                                        label={t('common.label.numero-matriculacion')}
                                        type="text"
                                        placeholder={t('common.label.numero-matriculacion')}
                                        name="registration_number"
                                        value={values.registration_number}
                                        onChange={(value) =>
                                            setFieldValue('registration_number', value.registration_number)
                                        }
                                    />
                                    <FieldError
                                        touched={touched}
                                        errors={errors}
                                        field={'registration_number'}
                                    /> */}

                                    <Select
                                        name="registration_country"
                                        label={t('common.label.pais-matriculacion')}
                                        placeholder="Select value"
                                        items={countries}
                                        value={data?.registration_country || values.registration_country}
                                        onChange={(value) =>
                                            setFieldValue('registration_country', value.registration_country)
                                        }
                                    />
                                    <FieldError
                                        touched={touched}
                                        errors={errors}
                                        field={'registration_country'}
                                    />
                                </div>
                            </div>
                            {/* <div className='w-3/12 border border-gray-400 rounded p-8'>
                                <div className="text-[15px]  text-gray-900 pb-4 pr-4 font-semibold">
                                    {t('common.label.compra')}
                                </div>
                                <div className='w-full'>

                                    <FieldError
                                        touched={touched}
                                        errors={errors}
                                        field={'purchase_company'}
                                    />

                                    <DatePicker
                                        name="purchase_date"
                                        type="date"
                                        label={t('common.form-label.fecha-compra')}
                                        value={
                                            (data ? dayjs(data.purchase_date).format('YYYY-MM-DD') : '') || values.purchase_date}
                                        onChange={(value) => {
                                            setFieldValue('purchase_date', value.purchase_date ? dayjs(value.purchase_date).format('YYYY-MM-DD') : null);
                                        }}
                                    />
                                    <FieldError
                                        touched={touched}
                                        errors={errors}
                                        field={'purchase_date'}
                                    />

                                    <div>
                                        {data?.purchase_invoice_display_url ? <div className='flex'>
                                            {!isDeleted ? <div className='flex cursor-pointer' onClick={() => openInNewTab(data?.purchase_invoice_display_url)}>
                                                <span className='border border-gray-400 rounded py-2 px-4 text-sm'>{t('common.label.ver-factura')}</span>
                                            </div> : ''}
                                            {!isDeleted ? <div className='flex cursor-pointer ml-8' onClick={() => {
                                                setFieldValue('purchase_invoice', null);
                                                setFieldValue('purchase_invoice_display_url', null);
                                                setIsDeleted(true);
                                            }}>
                                                <span className='border border-red-500 rounded p-2 text-sm text-red-500'>{t('common.button.delete-invoice')}</span>
                                            </div> : ''}
                                        </div> : ''
                                        }
                                    </div>
                                    <div className='w-full pt-2'>
                                        {id ? <span className="block text-sm font-semibold leading-6 text-gray-700">{data?.purchase_invoice_display_url && !isDeleted ? t('common.label.cambiar-factura') : t('common.label.add-factura')}</span> : ''}
                                        <FileInputElement
                                            name="purchase_invoice"
                                            accept={'image/png, image/jpeg'}
                                            onChange={(value) => {
                                                // Extraemos directamente el FileList del objeto que retorna el FileInputElement
                                                setFieldValue('purchase_invoice', value);
                                                setIsDeleted(false);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div> */}
                           {/*  <div className='w-6/12 border border-gray-400 rounded p-8'>
                                <div className="text-[15px]  text-gray-900 pb-4 pr-4 font-semibold">
                                    {t('GPS')}
                                </div>
                                <div className='flex space-x-4 w-full'>
                                    <div className='w-full'>
                                        <DatePicker
                                            name="gps_date"
                                            type="date"
                                            label={t('common.labels.date')}
                                            value={
                                                (data ? dayjs(data.gps_date).format('YYYY-MM-DD') : '') || values.gps_date}
                                            onChange={(value) => {
                                                setFieldValue('gps_date', value.gps_date ? dayjs(value.gps_date).format('YYYY-MM-DD') : null);
                                            }}
                                        />
                                        <FieldError
                                            touched={touched}
                                            errors={errors}
                                            field={'gps_date'}
                                        />
                                    </div>
                                   <div className='w-full'>
                                        <Input
                                            label={t('common.label.numero')}
                                            type="text"
                                            placeholder={t('common.label.numero')}
                                            name="gps_number"
                                            value={values.gps_number}
                                            onChange={(value) =>
                                                setFieldValue('gps_number', value.gps_number)
                                            }
                                        />
                                        <FieldError
                                            touched={touched}
                                            errors={errors}
                                            field={'gps_number'}
                                        />
                                    </div> 
                                </div>
                                <div className='flex space-x-4 w-full'>
                                    <div className='w-full'>
                                        <Input
                                            label={t('IMEI')}
                                            type="text"
                                            placeholder={t('IMEI')}
                                            name="gps_imei"
                                            value={values.gps_imei}
                                            onChange={(value) =>
                                                setFieldValue('gps_imei', value.gps_imei)
                                            }
                                        />
                                        <FieldError
                                            touched={touched}
                                            errors={errors}
                                            field={'gps_imei'}
                                        />
                                    </div>
                                    <div className='w-full'>
                                        <Input
                                            label={t('SIM')}
                                            type="text"
                                            placeholder={t('SIM')}
                                            name="gps_sim"
                                            value={values.gps_sim}
                                            onChange={(value) =>
                                                setFieldValue('gps_sim', value.gps_sim)
                                            }
                                        />
                                        <FieldError
                                            touched={touched}
                                            errors={errors}
                                            field={'gps_sim'}
                                        />
                                    </div>
                                </div>
                               <div className='flex space-x-4 w-full pt-4'>
                                    <Input
                                        label={t('common.form-label.descripcion')}
                                        type="text"
                                        placeholder={t('common.form-label.descripcion')}
                                        name="gps_description"
                                        value={values.gps_description}
                                        onChange={(value) =>
                                            setFieldValue('gps_description', value.gps_description)
                                        }
                                    />
                                </div>
                            </div> */}
                        </div>
                        <div className='w-full flex justify-between p-4'>
                            <div>
                                <div className='text-[14px]'>{t('common.label.creado-en-fecha')}: {data && dayjs(data.created).format('DD-MM-YYYY')}</div>
                                <div className='text-[14px]'>{t('common.label.modificado-en-fecha')}: {data && dayjs(data.updated).format('DD-MM-YYYY')}</div>
                            </div>

                            <div>
                                <Button
                                    label={t('common.button.save')}
                                    onClick={handleSubmit}
                                />
                            </div>
                        </div>

                    </form>
                )}
            </Formik>
        </>

    );
};
